import React, { useEffect, useState } from "react";
import { API } from "../../lib/storeApi";

const fmtWeek = (iso) => {
  const d = new Date(`${iso}T12:00:00`);
  const end = new Date(d); end.setDate(d.getDate() + 6);
  const f = (x) => x.toLocaleDateString("en-US", { month: "short", day: "numeric" });
  return `${f(d)} – ${f(end)}`;
};

export const AdminFinancing = ({ token }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    fetch(`${API}/admin/financing-clicks`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.json()).then(setData);
  }, [token]);
  if (!data) return <p className="text-sm text-slate-500" data-testid="financing-loading">Loading…</p>;
  const keys = Object.keys(data.sources);
  return (
    <div data-testid="admin-financing" className="bg-white rounded-xl border border-slate-200 overflow-x-auto">
      <p className="p-4 text-sm text-slate-600">"Apply for financing" taps per week (Mon–Sun, Eastern time). Every tap is counted.</p>
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-slate-500 text-xs uppercase">
          <tr>
            <th className="text-left p-3">Week</th>
            <th className="text-right p-3">Total</th>
            {keys.map((k) => <th key={k} className="text-right p-3 whitespace-nowrap">{data.sources[k]}</th>)}
          </tr>
        </thead>
        <tbody>
          {data.weeks.map((w, i) => (
            <tr key={w.week_start} data-testid={`financing-week-${i}`} className="border-t border-slate-100">
              <td className="p-3 whitespace-nowrap font-semibold text-[#0a1f44]">{fmtWeek(w.week_start)}{i === 0 && <span className="ml-2 text-xs text-[#3b9dff]">this week</span>}</td>
              <td className="p-3 text-right font-bold" data-testid={`financing-week-${i}-total`}>{w.total}</td>
              {keys.map((k) => <td key={k} className="p-3 text-right text-slate-600" data-testid={`financing-week-${i}-${k}`}>{w.by_source[k]}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
